// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"388":"2b3a23ed","415":"82ac58e7","581":"6d8058d4","668":"c295d21c"}[chunkId] + ".chunk.css";
};